import { render, staticRenderFns } from "./AdminEmailTemplateView.vue?vue&type=template&id=006d9b98"
import script from "./AdminEmailTemplateView.vue?vue&type=script&lang=js"
export * from "./AdminEmailTemplateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports